var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.66992 15.3344C2.66992 13.9194 3.232 12.5625 4.23251 11.562C5.23301 10.5615 6.58999 9.99938 8.00492 9.99938C9.41985 9.99938 10.7768 10.5615 11.7773 11.562C12.7778 12.5625 13.3399 13.9194 13.3399 15.3344H12.0062C12.0062 14.2732 11.5846 13.2554 10.8342 12.5051C10.0839 11.7547 9.06612 11.3331 8.00492 11.3331C6.94372 11.3331 5.92599 11.7547 5.17561 12.5051C4.42523 13.2554 4.00367 14.2732 4.00367 15.3344H2.66992ZM8.00492 9.3325C5.79423 9.3325 4.00367 7.54194 4.00367 5.33125C4.00367 3.12056 5.79423 1.33 8.00492 1.33C10.2156 1.33 12.0062 3.12056 12.0062 5.33125C12.0062 7.54194 10.2156 9.3325 8.00492 9.3325ZM8.00492 7.99875C9.47872 7.99875 10.6724 6.80504 10.6724 5.33125C10.6724 3.85746 9.47872 2.66375 8.00492 2.66375C6.53113 2.66375 5.33742 3.85746 5.33742 5.33125C5.33742 6.80504 6.53113 7.99875 8.00492 7.99875Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.1f6a694677333781c560d3886af8a079.svg";
export { ForwardRef as ReactComponent };